(() => {
  const initInfoPages = () => {
    const root = document.querySelector('.mykidss-info-page');
    if (!root) return;

    const shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root.replace(/\/$/, '') : '';
    const localizedPath = (path) => shopifyRoot + path;

    const policyBody = root.querySelector('.shopify-policy__body');
    const contentBody = policyBody || root.querySelector('.page-content__text');

    // Shopify injects its own policy H1 even when the premium hero already owns
    // the page-level H1. Replace the hidden duplicate with a neutral element.
    const nativePolicyTitle = root.querySelector('.shopify-policy__title h1');
    if (nativePolicyTitle) {
      const neutralTitle = document.createElement('div');
      neutralTitle.className = nativePolicyTitle.className;
      neutralTitle.textContent = nativePolicyTitle.textContent;
      nativePolicyTitle.replaceWith(neutralTitle);
    }

    // Remove the duplicated visual page title; the premium hero owns the single visible H1.
    if (contentBody) {
      const firstH1 = contentBody.querySelector(':scope > h1:first-child');
      if (firstH1) firstH1.setAttribute('aria-hidden', 'true');
    }

    // Shopify Terms of Service is generated mostly as paragraphs with <br> separators.
    // Promote its structural labels to real H2 headings so the document is scannable
    // and can participate in the same table of contents as Privacy Policy.
    if (policyBody && window.location.pathname.includes('/policies/terms-of-service')) {
      const rte = policyBody.querySelector('.rte');
      if (rte && !rte.dataset.mykidssStructured) {
        rte.dataset.mykidssStructured = 'true';

        let html = rte.innerHTML;

        // Overview becomes a proper section heading.
        html = html.replace(
          /<p>\s*<strong>PRZEGLĄD<\/strong>\s*<\/p>/i,
          '<h2>PRZEGLĄD</h2>'
        );

        // Chapter heading at the start of a generated paragraph.
        // Handles all Shopify variants:
        // 1) <p><br>ROZDZIAŁ...<br>body
        // 2) <p>ROZDZIAŁ...&nbsp;<br>body  (chapter 3)
        // 3) <p><br>ROZDZIAŁ...</p>        (chapter 9)
        html = html.replace(
          /<p>\s*(?:&nbsp;)?\s*(?:<br\s*\/?>\s*)?(ROZDZIAŁ\s+\d+\s*[–-]\s*[^<]*?)(?:&nbsp;)?\s*<br\s*\/?>/gi,
          '<h2>$1</h2><p>'
        );

        html = html.replace(
          /<p>\s*(?:&nbsp;)?\s*(?:<br\s*\/?>\s*)?(ROZDZIAŁ\s+\d+\s*[–-]\s*[^<]*?)(?:&nbsp;)?\s*<\/p>/gi,
          '<h2>$1</h2>'
        );

        // Chapter heading embedded later in the same paragraph (e.g. 23 → 24).
        html = html.replace(
          /<br\s*\/?>\s*(ROZDZIAŁ\s+\d+\s*[–-]\s*[^<]+?)(?:&nbsp;)?\s*<br\s*\/?>/gi,
          '</p><h2>$1</h2><p>'
        );

        // Remove empty paragraphs that can be created by the structural conversion.
        html = html.replace(/<p>\s*(?:&nbsp;)?\s*<\/p>/gi, '');

        // Add the missing / implicit internal policy links without changing legal wording.
        html = html.replace(
          /naszej Polityki prywatności\s*\./i,
          'naszej <a href="' + localizedPath('/policies/privacy-policy') + '">Polityki prywatności</a>.'
        );
        html = html.replace(
          /Polityką prywatności, którą można wyświetlić tutaj/i,
          '<a href="' + localizedPath('/policies/privacy-policy') + '">Polityką prywatności</a>, którą można wyświetlić tutaj'
        );
        html = html.replace(
          /polityką prywatności\s*\[LINK\]/i,
          '<a href="' + localizedPath('/policies/privacy-policy') + '">polityką prywatności</a>'
        );
        html = html.replace(
          /zgodnie z naszą polityką zwrotów/i,
          'zgodnie z naszą <a href="' + localizedPath('/policies/refund-policy') + '">polityką zwrotów</a>'
        );

        rte.innerHTML = html;
      }
    }

    // Refund Policy: promote generated strong labels to real H2 sections
    // and fix legacy mailto targets while preserving the visible legal wording.
    if (policyBody && window.location.pathname.includes('/policies/refund-policy')) {
      const rte = policyBody.querySelector('.rte');
      if (rte && !rte.dataset.mykidssRefundStructured) {
        rte.dataset.mykidssRefundStructured = 'true';

        Array.from(rte.querySelectorAll('p')).forEach((paragraph) => {
          const strong = paragraph.querySelector(':scope > strong:first-child');
          if (!strong) return;

          const label = strong.textContent.trim();
          if (!label) return;

          const knownSections = [
            'Uszkodzenia i problemy',
            'Wyjątki / towary niepodlegające zwrotom',
            'Wymiany',
            '14-dniowy okres odstąpienia od umowy w Unii Europejskiej',
            'Zwroty kosztów'
          ];
          if (!knownSections.some((item) => label.toLowerCase() === item.toLowerCase())) return;

          const heading = document.createElement('h2');
          heading.textContent = label;
          paragraph.parentNode.insertBefore(heading, paragraph);
          strong.remove();

          while (paragraph.firstChild && paragraph.firstChild.nodeName === 'BR') {
            paragraph.firstChild.remove();
          }
        });

        rte.querySelectorAll('a[href^="mailto:"]').forEach((link) => {
          if (link.textContent.trim().toLowerCase() === 'info@mykidss.com') {
            link.setAttribute('href', 'mailto:info@mykidss.com');
          }
        });

        rte.querySelectorAll('meta').forEach((node) => node.remove());
        rte.querySelectorAll('p').forEach((p) => {
          if (!p.textContent.trim() && !p.querySelector('img,video,iframe')) p.remove();
        });
      }
    }

    // Legal Notice: normalize numbered section headings, improve useful links,
    // and use customer-facing fulfilment wording without changing the underlying model.
    if (policyBody && window.location.pathname.includes('/policies/legal-notice')) {
      const rte = policyBody.querySelector('.rte');
      if (rte && !rte.dataset.mykidssLegalStructured) {
        rte.dataset.mykidssLegalStructured = 'true';

        Array.from(rte.querySelectorAll('h4')).forEach((heading) => {
          const text = heading.textContent.trim();
          if (/^\d+\./.test(text)) {
            const h2 = document.createElement('h2');
            h2.innerHTML = heading.innerHTML;
            heading.replaceWith(h2);
          } else if (/^NOTA PRAWNA/i.test(text)) {
            heading.classList.add('mykidss-info-document-kicker');
            heading.setAttribute('data-exclude-toc', 'true');
          }
        });

        rte.innerHTML = rte.innerHTML.replace(
          /produktów importowanych oraz realizowanych w modelu dropshipping\.?/i,
          'produktów wybranych marek, w tym wysyłanych bezpośrednio z magazynów wybranych partnerów.'
        );

        Array.from(rte.querySelectorAll('p, li')).forEach((node) => {
          if (/formularz kontaktowy/i.test(node.textContent) && !node.querySelector('a')) {
            node.innerHTML = node.innerHTML.replace(
              /formularz kontaktowy/i,
              '<a href="' + localizedPath('/pages/kontakt') + '">formularz kontaktowy</a>'
            );
          }
          if (/^e-mail:\s*info@mykidss\.com/i.test(node.textContent.trim()) && !node.querySelector('a')) {
            node.innerHTML = node.innerHTML.replace(
              /info@mykidss\.com/i,
              '<a href="mailto:info@mykidss.com">info@mykidss.com</a>'
            );
          }
        });
      }
    }

    // Returns & Refunds: remove imported citation artefacts and align customer-facing
    // timing with the canonical Refund Policy.
    if (contentBody && window.location.pathname.includes('/pages/zwroty-i-refundacje') || window.location.pathname.includes('/pages/returns-refunds')) {
      if (!contentBody.dataset.mykidssReturnsStructured) {
        contentBody.dataset.mykidssReturnsStructured = 'true';

        contentBody.querySelectorAll('.citation-nbsp, .citation, a[href*="wind.net.pl"]').forEach((node) => {
          const wrapper = node.closest('.inline-flex');
          if (wrapper && wrapper !== contentBody) wrapper.remove();
          else node.remove();
        });

        Array.from(contentBody.querySelectorAll('h2')).forEach((heading) => {
          if (heading.textContent.trim().toLowerCase() === 'returns & refunds') {
            heading.setAttribute('data-exclude-toc', 'true');
            heading.classList.add('mykidss-info-duplicate-title');
          }
        });

        Array.from(contentBody.querySelectorAll('p')).forEach((p) => {
          p.innerHTML = p.innerHTML.replace(
            /within 30 days of the original order date/i,
            'within 30 days of receiving the item'
          );
          p.innerHTML = p.innerHTML.replace(
            /usually completed within(?:<span[^>]*>[^<]*<\/span>)?\s*<strong>3–7 business days<\/strong>(?:<span[^>]*>[^<]*<\/span>)?\s*after approval/i,
            'processed within <strong>10 business days</strong> after approval'
          );
          p.innerHTML = p.innerHTML.replace(
            /Return shipping costs are charged according to the standard shipping rates\. In most cases, return shipping costs may be passed on to the customer\./i,
            'Return shipping costs are normally paid by the customer unless applicable law or the specific return circumstances require otherwise.'
          );
        });
      }
    }

    // Shipping & Payments already contains semantic H2 headings. The generic TOC below
    // now also supports regular Page content, so it receives the same left navigation.
    if (contentBody && window.location.pathname.includes('/pages/dostawa-i-platnosci')) {
      contentBody.querySelectorAll('h2').forEach((heading) => {
        heading.style.scrollMarginTop = '110px';
      });
    }

    const toc = root.querySelector('[data-mykidss-policy-toc]');
    const tocLinks = root.querySelector('[data-mykidss-policy-toc-links]');
    const tocSource = policyBody || contentBody;
    if (!toc || !tocLinks || !tocSource) return;

    const headings = Array.from(tocSource.querySelectorAll('h2, h3, h4'))
      .filter((heading) =>
        heading.textContent.trim().length > 2 &&
        !heading.hasAttribute('data-exclude-toc')
      )
      .slice(0, 30);

    if (headings.length < 2) return;

    const used = new Set();
    headings.forEach((heading, index) => {
      let slug = heading.textContent.trim().toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 48) || ('section-' + (index + 1));

      let unique = slug;
      let n = 2;
      while (used.has(unique)) unique = slug + '-' + n++;
      used.add(unique);
      heading.id = unique;

      const link = document.createElement('a');
      link.href = '#' + unique;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', (event) => {
        event.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + unique);
      });
      tocLinks.appendChild(link);
    });

    toc.hidden = false;

    // Always open mobile/tablet TOC from its first item.
    // This prevents a restored horizontal scroll position from cutting off
    // the first navigation pill on policy and footer information pages.
    const mykidssMobileTocReset = () => {
      if (window.matchMedia('(max-width: 989px)').matches) {
        tocLinks.scrollLeft = 0;
      }
    };
    mykidssMobileTocReset();
    requestAnimationFrame(mykidssMobileTocReset);

    const tocAnchors = Array.from(tocLinks.querySelectorAll('a'));
    const setActiveTocItem = (heading) => {
      const activeLink = tocAnchors.find((link) => link.getAttribute('href') === '#' + heading.id);
      if (!activeLink) return;

      tocAnchors.forEach((link) => {
        const isActive = link === activeLink;
        link.classList.toggle('is-active', isActive);
        if (isActive) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });

      if (window.matchMedia('(max-width: 989px)').matches) {
        const targetLeft = activeLink.offsetLeft - 14;
        tocLinks.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      }
    };

    let tocScrollTicking = false;
    const updateActiveTocItem = () => {
      tocScrollTicking = false;
      const offset = 190;
      let current = headings[0];

      headings.forEach((heading) => {
        if (heading.getBoundingClientRect().top <= offset) current = heading;
      });

      setActiveTocItem(current);
    };

    window.addEventListener('scroll', () => {
      if (tocScrollTicking) return;
      tocScrollTicking = true;
      requestAnimationFrame(updateActiveTocItem);
    }, { passive: true });

    window.addEventListener('resize', updateActiveTocItem, { passive: true });
    updateActiveTocItem();

    const shell = toc.closest('.mykidss-info-shell');
    if (shell) shell.classList.add('has-toc');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfoPages, { once: true });
  } else {
    initInfoPages();
  }
})();
